import z from "zod";

const ruleSchema = z.object({
  id: z.string(),
  text: z.string(),
  subtext: z.string(),
  rule_type: z.union([
    z.literal("content"),
    z.literal("account"),
    z.literal("group"),
  ]),
});

type Rule = z.infer<typeof ruleSchema>;

export { ruleSchema, type Rule };
